// removed by extract-text-webpack-plugin
module.exports = {"container":"_1dWAS","meta-item":"_1ssAN","heading":"_1G9vq","value":"BZ4C-","icon":"e7cXw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/Meta/Meta.scss
// module id = ./src/components/Page/Meta/Meta.scss
// module chunks = 5